var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item.id)?_c('h3',{class:_vm.css},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.item.name))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }